import apiClient from '@/api/apiClient';
import { handleError, getAuthData, prepareModel, validateId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    modelForm: {},
    dataCrud: [],
    checkboxNone: 0,
    isNewRecord: true,
    status: '',
  },

  getters: {
    schema: (state) => state.schema,
    modelForm: (state) => state.modelForm,
    dataCrud: (state) => state.dataCrud,
    checkboxNone: (state) => state.checkboxNone,
    isNewRecord: (state) => state.isNewRecord,
    status: (state) => state.status,
  },

  mutations: {
    SET_SCHEMA(state, schema) {
      state.schema = schema;
    },
    SET_RECORDS(state, { recordsData }) {
      state.modelForm = typeof recordsData?.modelForm === 'object' ? recordsData.modelForm : {};
      state.dataCrud = Array.isArray(recordsData?.dataCrud) ? recordsData.dataCrud : [];
      state.checkboxNone = recordsData?.checkboxNone;
      state.isNewRecord = Boolean(recordsData?.isNewRecord);
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
  },

  actions: {
    async fetchSchema({ commit }) {
      try {
        commit('SET_STATUS', 'loading');
        const responses = await Promise.all([
          apiClient.caxACGxMemorySchema(),
          apiClient.catLevelProof(),
          apiClient.catCognitMemoryCond(),
          apiClient.catCognitMemoryAmnesiaOrigin(),
          apiClient.catCognitMemoryAmnesiaType(),
          apiClient.catCognitMemoryAmnesiaEpisode(),
        ]);

        let id1 = 'D';
        const resCat2 = await apiClient.catLevelDescription(id1);
        const catLevelDescriptionD = resCat2.data.data;

        const [
          schemaRes,
          catLevelProof,
          catCognitMemoryCond,
          catCognitMemoryAmnesiaOrigin,
          catCognitMemoryAmnesiaType,
          catCognitMemoryAmnesiaEpisode,
        ] = responses.map((res) => res?.data ?? {});

        if (!schemaRes.formCrud) throw new Error('Estructura de schema inválida.');
        if (!schemaRes.schemaForm) throw new Error('Estructura de schema inválida.');

        const schema = structuredClone(schemaRes);
        schema.schemaForm.i1_cognitive_memory_level_description_id.items = catLevelDescriptionD;
        schema.schemaForm.i1_cognitive_memory_proof.items = catLevelProof.data ?? [];
        schema.schemaForm.i2_cognitive_memory_level_description_id.items = catLevelDescriptionD;
        schema.schemaForm.i2_cognitive_memory_proof.items = catLevelProof.data ?? [];
        schema.schemaForm.i3_cognitive_memory_level_description_id.items = catLevelDescriptionD;
        schema.schemaForm.i3_cognitive_memory_proof.items = catLevelProof.data ?? [];
        schema.schemaForm.i4_cognitive_memory_level_description_id.items = catLevelDescriptionD;
        schema.schemaForm.i4_cognitive_memory_proof.items = catLevelProof.data ?? [];
        schema.schemaForm.i5_cognitive_memory_level_description_id.items = catLevelDescriptionD;
        schema.schemaForm.i5_cognitive_memory_proof.items = catLevelProof.data ?? [];
        schema.schemaForm.i6_cognitive_memory_level_description_id.items = catLevelDescriptionD;
        schema.schemaForm.i6_cognitive_memory_proof.items = catLevelProof.data ?? [];
        schema.schemaForm.i7_cognitive_memory_level_description_id.items = catLevelDescriptionD;
        schema.schemaForm.i7_cognitive_memory_proof.items = catLevelProof.data ?? [];
        schema.schemaForm.i8_cognitive_memory_condition_id.items = catCognitMemoryCond.data ?? [];
        schema.formCrud.cognitMemoryAmnesiaOrigin.items = catCognitMemoryAmnesiaOrigin.data ?? [];
        schema.formCrud.cognitMemoryAmnesiaType.items = catCognitMemoryAmnesiaType.data ?? [];
        schema.formCrud.cognitMemoryAmnesiaEpisode.items =
          catCognitMemoryAmnesiaEpisode.data ?? [];

        commit('SET_SCHEMA', schema);
      } catch (error) {
        handleError(error, commit);
      }
    },

    async fetchRecords({ commit, rootState }) {
      try {
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        const res = await apiClient.modelCAxACGxMemory(clinicalHistories_id, institutions_profes_id);
        const recordsData = res?.data?.data ?? [];

        commit('SET_RECORDS', { recordsData });
        commit('SET_STATUS', 'loaded');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async createRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'create');
        const preparedModel = prepareModel(rootState, model);
        await apiClient.createCAxACGxMemory(preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async updateRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'update');
        const { clinicalHistories_id } = getAuthData(rootState);
        const preparedModel = prepareModel(rootState, model);
        await apiClient.updateCAxACGxMemory(clinicalHistories_id, preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async removeRecord({ commit, rootState }, { id }) {
      try {
        commit('SET_STATUS', 'remove');
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        validateId(id);
        await apiClient.deleteCAxACGxMemory(id, clinicalHistories_id, institutions_profes_id);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },
  },
};
